export default "__VITE_ASSET__DmiHHhVs__"